var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateRoleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6,8.124h4.9A3.674,3.674,0,0,0,30.168,11.8h2.449a3.674,3.674,0,0,0,3.674-3.674V5.674A3.674,3.674,0,0,0,32.618,2H30.168a3.674,3.674,0,0,0-3.674,3.674H21.6a3.674,3.674,0,0,0-3.674,3.674v8.573H11.8a3.674,3.674,0,0,0-3.674-3.674H5.674A3.674,3.674,0,0,0,2,17.921v2.449a3.674,3.674,0,0,0,3.674,3.674H8.124A3.674,3.674,0,0,0,11.8,20.371h6.124v8.573A3.674,3.674,0,0,0,21.6,32.618h4.9a3.674,3.674,0,0,0,3.674,3.674h2.449a3.674,3.674,0,0,0,3.674-3.674V30.168a3.674,3.674,0,0,0-3.674-3.674H30.168a3.674,3.674,0,0,0-3.674,3.674H21.6a1.225,1.225,0,0,1-1.225-1.225V20.371h6.124a3.674,3.674,0,0,0,3.674,3.674h2.449a3.674,3.674,0,0,0,3.674-3.674V17.921a3.674,3.674,0,0,0-3.674-3.674H30.168a3.674,3.674,0,0,0-3.674,3.674H20.371V9.348A1.225,1.225,0,0,1,21.6,8.124Zm7.348-2.449a1.225,1.225,0,0,1,1.225-1.225h2.449a1.225,1.225,0,0,1,1.225,1.225V8.124a1.225,1.225,0,0,1-1.225,1.225H30.168a1.225,1.225,0,0,1-1.225-1.225Zm-19.6,14.7A1.225,1.225,0,0,1,8.124,21.6H5.674a1.225,1.225,0,0,1-1.225-1.225V17.921A1.225,1.225,0,0,1,5.674,16.7H8.124a1.225,1.225,0,0,1,1.225,1.225Zm19.6,9.8a1.225,1.225,0,0,1,1.225-1.225h2.449a1.225,1.225,0,0,1,1.225,1.225v2.449a1.225,1.225,0,0,1-1.225,1.225H30.168a1.225,1.225,0,0,1-1.225-1.225Zm0-12.247A1.225,1.225,0,0,1,30.168,16.7h2.449a1.225,1.225,0,0,1,1.225,1.225v2.449A1.225,1.225,0,0,1,32.618,21.6H30.168a1.225,1.225,0,0,1-1.225-1.225Z",
    transform: "translate(-2 -2)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateRoleIcon);
export default __webpack_public_path__ + "static/media/create-role-icon.18ebbc3ef6940b2942fa47a4074bc74a.svg";
export { ForwardRef as ReactComponent };